import { queryFor } from "@visioni/a3s-client-api/app";
import { listScenariosEndpoint } from "../client-messages/scenarios";

/**
 * React Query options factory for the tenant scenario-status list endpoint.
 *
 * Pattern mirrored from `features/a3s-media/src/app/queries.ts` —
 * `queryFor(endpoint)` returns a function `(apiConfig, pathParams)` that
 * produces a TanStack-Query options object with the queryKey, queryFn, and
 * decode boundary all derived from the endpoint definition. Callers spread
 * the result into `useQuery` and add their own UX flags (enabled, refetch
 * intervals, etc).
 */
export const scenariosQuery = queryFor(listScenariosEndpoint);
